var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dealerIsHere)?_c('div',{staticClass:"game"},[_c('Message'),_c('Hands'),(_vm.playerHasChips)?_c('div',[_c('Actions'),_c('Chips')],1):_c('div',[_c('Stats')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }